import { render, staticRenderFns } from "./ad-keyword-relate-asin-modal.vue?vue&type=template&id=01bb9b2c&"
import script from "./ad-keyword-relate-asin-modal.vue?vue&type=script&lang=js&"
export * from "./ad-keyword-relate-asin-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports